<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">よくあるご質問</h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          FAQ
        </h3>
        <div class="l-service-content-inner">
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>会社の設立はいつですか？</li>
            <li class="ir_a"><span>A</span>1994年4月18日です。</li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>株式が上場されたのはいつですか？</li>
            <li class="ir_a"><span>A</span>2017年4月18日です。</li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>上場市場はどこですか？</li>
            <li class="ir_a"><span>A</span>東京証券取引所グロース市場です。</li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>証券コードは何番ですか？</li>
            <li class="ir_a">
              <span>A</span>6548です。なお、業種は「サービス業」です。
            </li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>株式の売買単位は何株ですか？</li>
            <li class="ir_a"><span>A</span>株式の売買単位は100株単位です。</li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>決算期はいつですか？</li>
            <li class="ir_a"><span>A</span>毎年6月30日です。</li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>決算発表はいつですか？</li>
            <li class="ir_a">
              <span>A</span>
              <a href="/ir/schedule">「IRカレンダー」</a>をご覧下さい。
            </li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>株主総会はいつですか？</li>
            <li class="ir_a">
              <span>A</span>
              <a href="/ir/schedule">「IRカレンダー」</a>をご覧下さい。
            </li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>事業内容を教えて下さい。</li>
            <li class="ir_a">
              <span>A</span>
              <a href="/ir/business">「事業内容」</a>ページをご覧下さい。
            </li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>最近の業績について教えて下さい。</li>
            <li class="ir_a">
              <span>A</span>
              <a href="/ir/highlight">「業績ハイライト」</a>ページをご覧下さい。
            </li>
          </ul>
          <ul class="ir_faq">
            <li class="ir_q"><span>Q</span>業績見通しについて教えて下さい。</li>
            <li class="ir_a">
              <span>A</span>
              業績見通しにつきましてはIRライブラリーの
              <a href="/ir/library">決算短信</a>をご覧下さい。
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "よくあるご質問",
      titleTemplate: "よくあるご質問 | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
